import moment from 'moment';
import 'moment/locale/pt-br';

const formatSecondsToHour = (seconds: any = null) => (seconds ? moment('2015-01-01').startOf('day').seconds(seconds).format('H[H]') : '');

export default formatSecondsToHour;
